import { combineReducers } from 'redux';
import undoable from 'redux-undo';

import searchCategory from 'packages/store/searchCategory/searchCategory.reducer';
import newDesign from 'packages/store/newDesign/newDesign.reducer';
import palettes from 'packages/store/brandColors/colorPalettes.reducer';
import importTemplate from 'packages/store/importTemplate/importTemplate.reducer';
import sharing from 'packages/store/sharing/sharing.reducer';
import brandColors from 'packages/store/brandColors/brandColors.reducer';
import categories from 'packages/store/categories/categories.reducer';
import review from 'packages/store/review/review.reducer';
import gallery from 'packages/store/gallery/gallery.reducer';
import * as types from './types';
import userReducer from 'packages/store/user/user.reducer';
import menuReducer from 'packages/store/menu/menu.reducer';
import general from 'packages/store/general/general.reducer';
import creatives from 'packages/store/creatives/creatives.reducer';
import assets from 'packages/store/assets/assets.reducer';
import templates from 'packages/store/templates/templates.reducer';
import creativeEditor from 'packages/store/creativeEditor/creativeEditor.reducer';
import collections from 'packages/store/collections/collections.reducer';
import presets from 'packages/store/presets/presets.reudcer';
import platform from 'packages/store/platform/platform.reducer';
import figma from 'packages/store/figma/figma.reducer';
import activityFeed from 'packages/store/activityFeed/activityFeed.reducer';
import fontManagement from 'packages/store/fontManagement/fontManagement.reducer';

const rootReducer = combineReducers({
    user: userReducer,
    menu: menuReducer,
    general,
    creatives,
    assets,
    templates,
    creativeEditor: undoable(creativeEditor, {
        ignoreInitialState: true,
        syncFilter: true,
        filter: (action) => {
            if (action.type === types.SET_EDITOR_ELEMENTS) {
                return action.pushToHistory;
            }

            return false;
        },
    }),
    collections,
    presets,
    platform,
    newDesign,
    palettes,
    gallery,
    importTemplate,
    sharing,
    brandColors,
    categories,
    searchCategory,
    review,
    figma,
    activityFeed,
    fontManagement,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
